export default "__VITE_PUBLIC_ASSET__e76df22d__"